module.exports = __webpack_public_path__ + "img/telephone-fill.3febd885.svg";